import { combineReducers } from 'redux';

import contentLinkUrls from './contentLinkUrls';
import linkTaskRequest from './linkTaskRequest';

const content = combineReducers({
  contentLinkUrls,
  linkTaskRequest,
});

export default content;
